const clone = (obj: string | unknown): unknown => JSON.parse(JSON.stringify(obj));
export default clone;
